/*eslint complexity: ["error", 35]*/
import React, { useEffect, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Tabs from '../../../app/components/Tabs';
import { useAuth } from '../../../common/hooks/useAuth';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  CreateUpdateExamWithTestsDtoHealthcareEnum,
  CreateUpdateExamWithTestsDtoTakenCareOfEnum,
  CreateUpdateExamWithTestsDtoTypeEnum,
  CreateUpdateSupportingExaminationDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { TestGivingProps } from '../../components/TestGiving/utilsTestGiving';
import { TestGiving } from '../TestGivingView/TestGiving';

type ParamTypes = {
  visitId: string;
};

export const TestGivingWithRegistrationView: React.FC = () => {
  const { visitId } = useParams<ParamTypes>();
  const spd = useSpdCore();
  const auth = useAuth();

  const [formData, setFormData] = useState<TestGivingProps>({
    testsKeys: [],
    countOfExams: 1,
  });

  useEffect(() => {
    if (visitId) {
      spd.visits
        .get(visitId)
        .then(visit => {
          setFormData({
            ...formData,
            visitRegistrationId: visitId,
            healthcareFacilityId:
              visit?.appointmentChannel?.healthcareFacility?.id,
            batteryKey: visit?.examType?.battery?.id,
            testsKeys: visit?.examType?.battery?.tests || [],
            articlePsychologistsKeys:
              visit?.examType?.battery?.articlePsychologistsIds || undefined,
            articleDoctorsKeys:
              visit?.examType?.battery?.articleDoctorsIds || undefined,
            examinedFirstname: visit?.firstname || undefined,
            examinedSurname: visit?.surname || undefined,
            examinedEmail: visit?.mail || undefined,
            examinedPhone: visit?.phone || undefined,
            examinedInvoiceName: visit?.invoiceName || undefined,
            examinedInvoiceAddress: visit?.invoiceAddress || undefined,
            examinedNip: visit?.invoiceNip || undefined,
            harmfulFactorsIds: visit?.harmfulFactorsIds || undefined,
          });
        })
        .catch(error => {
          console.error('Nie udało się pobrać wizyty', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitId]);

  //TODO - onSave mamy w dwoch miejscach - do przemyslenia, co tu zrobic
  const onSave = (testGivingProps: TestGivingProps) => {
    spd.exams
      .createWithTests({
        ...testGivingProps,
        ...{
          examinedId: testGivingProps.examinedKey,
          psychologistUID: auth.currentUser?.uid,
          testsId: testGivingProps.testsKeys,
          articlePsychologistsIds: testGivingProps.articlePsychologistsKeys,
          articleDoctorsIds: testGivingProps.articleDoctorsKeys,
          countOfExams: +(testGivingProps.countOfExams || 0),
          occupationalMedicineCategory:
            testGivingProps.occupMedicineCategory?.split(','),
          occupationalMedicineText: testGivingProps.occupMedicineText,
          type: testGivingProps.type as unknown as CreateUpdateExamWithTestsDtoTypeEnum,
          kindOfScience: testGivingProps.kindOfScience,
          takenCareOf:
            testGivingProps.takenCareOf as unknown as CreateUpdateExamWithTestsDtoTakenCareOfEnum,
          supportingExamination:
            testGivingProps.supportExam as unknown as CreateUpdateSupportingExaminationDto[],
          companyId:
            testGivingProps.company && 'id' in testGivingProps.company
              ? testGivingProps.company.id
              : undefined,
          name: testGivingProps.company?.name,
          address: testGivingProps.company?.address,
          nip: testGivingProps.company?.nip,
          email: testGivingProps.company?.email,
          sendCompanyEmail: testGivingProps.sendCompanyEmail,
          healthcare:
            testGivingProps.healthcare as unknown as CreateUpdateExamWithTestsDtoHealthcareEnum,
          healthcareFacilityId: testGivingProps.healthcareFacilityId,
          batteryId: testGivingProps.batteryKey,
          visitRegistrationId: visitId,
        },
      })
      .then(exam => {
        if (exam) {
          setFormData({
            ...testGivingProps,
            pin: exam.map(e => e.pin).join(', '),
            examsNumber: exam.map(e => e.number).join(', '),
            examsKeys: exam.map(e => e.id),
            countOfExams: exam.length,
            examPackage: (exam && exam[0].examPackage) || undefined,
          });
        }
      })
      .catch(error => {
        console.error('Nie udało się zapisać badania', error);
      });
  };

  const handleSetFormData = (newFormData: TestGivingProps) => {
    setFormData(newFormData);
  };

  return (
    <Card>
      <Tabs defaultActiveKey="testGiving" id="testGiving" className="mb-3">
        <Tab eventKey="testGiving" title="Zadawanie testów" className="m-3">
          <TestGiving
            modeOnlyOne={true}
            formData={formData}
            setFormData={handleSetFormData}
            onSave={onSave}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
